import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaymentMethod } from '../../shared/models/payment-method';
import { environment } from '../../../environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {

  private apiUrl = `${environment.apiUrl}/payment-methods`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<PaymentMethod[]> {
    return this.http.get<PaymentMethod[]>(this.apiUrl);
  }

  // Obtener solo activos
  getActive(): Observable<PaymentMethod[]> {
    return this.http.get<PaymentMethod[]>(`${this.apiUrl}/active`);
  }

  // Crear nuevo
  create(method: PaymentMethod): Observable<PaymentMethod> {
    return this.http.post<PaymentMethod>(this.apiUrl, method);
  }

  // Activar / Desactivar
  toggle(id: number): Observable<PaymentMethod> {
    return this.http.patch<PaymentMethod>(`${this.apiUrl}/${id}/toggle`, {});
  }

  // Eliminar
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}